import React, { useContext, useState } from 'react';

import { useQuery } from '@apollo/client';
import { faEdit } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { capitalize } from 'lodash';
import moment from 'moment';
import { Button, CardText, Col, Row, Tooltip } from 'reactstrap';

import FormatPhoneNumber from '../../../components/FormatPhoneNumber/FormatPhoneNumber';
import GoogleMaps from '../../../components/GoogleMaps/GoogleMaps';
import Loading from '../../../components/Loading/Loading';
import PriceFormatter from '../../../components/PriceFormatter/PriceFormatter';
import appRouter from '../../../services/AppRouter/AppRouter';
import authService from '../../../services/Auth';
import opportunityAssigmentRequest from '../../../services/opportunityAssigment/gqlSchema';
import AssignmentContext from './assignment.context';
import SelectLeadStatut from './SelectLeadStatut';
import TextFieldComment from './TextFieldComment';

const AssignmentInfos = props => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const { urlAffaire } = useContext(AssignmentContext);
  const { loading, error, data } = useQuery(opportunityAssigmentRequest.Query.opportunityAssigment, {
    variables: { id: props.assignmentId },
  });

  if (loading || error) {
    return <Loading type={'spinkit'} />;
  }

  const o = data?.opportunityAssigment;
  const formatDate = date => moment(date).format('DD/MM/YYYY HH:mm');
  const exposures = {
    south: 'Sud',
    north: 'Nord',
    east: 'Est',
    west: 'Ouest',
  };
  const exposure = exposure => exposures[exposure.toString().toLowerCase()];

  const defaultPosition = {
    latLng: {
      lat: parseFloat(o.opportunity?.property?.latitude) || 46.6318067,
      lng: parseFloat(o.opportunity?.property?.longitude) || 2.3746823,
    },
  };
  let defaultZoom = 14;

  const nbrStar = o.opportunity?.appointments.length > 0 ? 4 : o.opportunity.score.star;

  const renderStars = () => {
    let render = [];
    for (let i = 1; i < 5; i++) {
      const color = i <= nbrStar ? '#ff7700' : '#98989898';
      render.push(<i key={i} className='fa fa-star font-xl ml-1' style={{ color }}></i>);
    }

    return render;
  };

  const getEstimationReason = reason => {
    const reasons = {
      TOO_LOW: 'Estimation trop basse',
      LOW: 'Estimation basse',
      REASONABLE: 'Estimation juste',
      HIGH: 'Estimation haute',
      TOO_HIGH: 'Estimation trop haute',
    };

    return reasons[reason];
  };

  const leadEstimation = {
    leadEstimationPrice: o.opportunity?.estimations?.[0]?.leadEstimationPrice || null,
    leadEstimationThought: o.opportunity?.estimations?.[0]?.leadEstimationThought || null,
    leadEstimationReason: o.opportunity?.estimations?.[0]?.leadEstimationReason || null,
  };

  const getOrigineLeadType = originLeadType => {
    switch (originLeadType) {
      case 'BUYER':
        return 'Acheteur';
      case 'NO_INTENT':
      case 'APPLICANT':
      case 'SELLER':
        return 'Vendeur';
      case 'PRO':
        return 'Professionnel';
      default:
        return 'Vendeur';
    }
  };

  const rapportPath = authService.findUserCompany().code === 'OPTIMHOME' ? 'valorize' : 'precisio';

  return (
    <>
      {o.opportunity.owners?.[0] && (
        <>
          <h2>Détails du lead</h2>
          <hr className='mt-0' />
          <Row className='mt-0 mb-0'>
            <Col className='col-6'>
              <CardText className='mb-1'>
                <strong>Nom</strong>
              </CardText>
            </Col>
            <Col className='col-6'>
              <CardText className='mb-1'>{capitalize(o.opportunity?.owners?.[0].name)}</CardText>
            </Col>
          </Row>
          <Row className='mt-0 mb-0'>
            <Col className='col-6'>
              <CardText className='mb-1'>
                <strong>Prénom</strong>
              </CardText>
            </Col>
            <Col className='col-6'>
              <CardText className='mb-1'>{capitalize(o.opportunity?.owners?.[0].firstname)}</CardText>
            </Col>
          </Row>
          <Row className='mt-0 mb-0'>
            <Col className='col-6'>
              <CardText className='mb-1'></CardText>
            </Col>
            <Col className='col-6'>
              <CardText className='mb-1'>
                <a href={'tel:' + o.opportunity?.owners?.[0].phone}>
                  <FormatPhoneNumber>{o.opportunity?.owners?.[0].phone}</FormatPhoneNumber>
                </a>
              </CardText>
            </Col>
          </Row>
          <Row className='mt-0 mb-0'>
            <Col className='col-6'>
              <CardText className='mb-1'></CardText>
            </Col>
            <Col className='col-6'>
              <CardText className='mb-1'>
                <a href={'mailto:' + o.opportunity?.owners?.[0].contact.email}>
                  {o.opportunity?.owners?.[0].contact.email}
                </a>
              </CardText>
            </Col>
          </Row>
        </>
      )}

      <Row className='mt-0 mb-0'>
        <Col className='col-6'>
          <CardText className='mb-1'>
            <strong>Date de l'estimation</strong>
          </CardText>
        </Col>
        <Col className='col-6'>
          <CardText className='mb-1'>{formatDate(o.opportunity.createdAt)}</CardText>
        </Col>
      </Row>
      {getOrigineLeadType(o.opportunity.originLeadType) === 'Vendeur' && (
        <Row className='mt-0 mb-0'>
          <Col className='col-6'>
            <CardText className='mb-1'>
              <strong>
                Pré-qualification du lead
                <i id='tooltip' className='fa fa-info-circle font-xl ml-1' title=''></i>
                <Tooltip
                  placement='top'
                  isOpen={tooltipOpen}
                  autohide={false}
                  target='tooltip'
                  toggle={() => setTooltipOpen(!tooltipOpen)}
                >
                  <p style={{ textAlign: 'left' }}>
                    1* : lead froid : projet de vente à travailler dans une optique moyen voir long-terme.
                  </p>
                  <p style={{ textAlign: 'left' }}>
                    2* : lead tiède : projet de vente en réflexion qui ne demande qu’à progresser.
                  </p>
                  <p style={{ textAlign: 'left' }}>
                    3* : lead chaud : projet de vente concret et à convertir rapidement.
                  </p>
                  <p style={{ textAlign: 'left' }}>
                    4* : lead rendez-vous : propriétaire souhaitant rencontrer un professionnel, une belle opportunité à
                    saisir.
                  </p>
                </Tooltip>
              </strong>
            </CardText>
          </Col>
          <Col className='col-6'>
            <CardText className='mb-1'>
              {renderStars().map((s, i) => (
                <span key={i}>{s}</span>
              ))}
            </CardText>
          </Col>
        </Row>
      )}

      {o.opportunity.callcenter.length > 0 && (
        <Row className='mt-0 mb-0'>
          <Col className='col-6'>
            <CardText className='mb-1'>
              <strong>Résumé de l'échange par SMS</strong>
            </CardText>
          </Col>
          <Col className='col-6'>
            <CardText className='mb-1'>
              <a href={o.opportunity.callcenter[0].transcriptUrl} target='_blank' rel='noopener noreferrer'>
                <i id='pdf-file' className='fa fa-file-pdf-o font-xl ml-1' title='' style={{ color: '#EE0000' }}></i>
              </a>
            </CardText>
          </Col>
        </Row>
      )}

      {leadEstimation.leadEstimationPrice && (
        <Row className='mt-0 mb-0'>
          <Col className='col-6'>
            <CardText className='mb-1'>
              <strong>Estimation du prix par l'internaute</strong>
            </CardText>
          </Col>
          <Col className='col-6'>
            <CardText className='mb-1'>
              <PriceFormatter integerOnly={true}>{leadEstimation.leadEstimationPrice}</PriceFormatter>
            </CardText>
          </Col>
        </Row>
      )}

      {leadEstimation.leadEstimationReason && (
        <Row className='mt-0 mb-0'>
          <Col className='col-6'>
            <CardText className='mb-1'>
              <strong>Commentaire de l'internaute sur l'estimation</strong>
            </CardText>
          </Col>
          <Col className='col-6'>
            <CardText className='mb-1'>{leadEstimation.leadEstimationReason}</CardText>
          </Col>
        </Row>
      )}

      {leadEstimation.leadEstimationThought && (
        <Row className='mt-0 mb-0'>
          <Col className='col-6'>
            <CardText className='mb-1'>
              <strong>Avis de l'internaute sur l'estimation</strong>
            </CardText>
          </Col>
          <Col className='col-6'>
            <CardText className='mb-1'>{getEstimationReason(leadEstimation.leadEstimationThought)}</CardText>
          </Col>
        </Row>
      )}

      {o.opportunity.property.description && (
        <Row className='mt-0 mb-0'>
          <Col className='col-12'>
            <CardText className='mb-1'>
              <strong>Description</strong>
            </CardText>
          </Col>
          <Col className='col-12'>
            <CardText className='mb-1'>{o.opportunity.property.description}</CardText>
          </Col>
        </Row>
      )}

      {o.opportunity?.appointments && o.opportunity?.appointments.length > 0 && (
        <Row className='mt-0 mb-0'>
          <Col className='col-12'>
            <hr />
            <CardText className='mb-1'>
              <p className='mt-2 mb-2'>
                <strong>Rendez-vous ToutvaBiens</strong>
              </p>
              <p className='mb-2'>
                Un propriétaire souhaite rencontrer un conseiller immobilier pour son projet de vente, suite à une
                estimation en ligne, et à une qualification par notre centre d'appel.
              </p>
              <p className='mb-2'>Disponibilités du vendeur :</p>
            </CardText>
          </Col>
          <Col className='col-12'>
            <ul>
              {o.opportunity.appointments.map((value, index) => {
                return (
                  <li key={index} className='mb-2'>
                    <CardText className='mb-2'>
                      le {moment(new Date(value.start)).utc().format('DD/MM à HH:mm')}{' '}
                      {value.location && <>à {value.location} </>}
                    </CardText>
                  </li>
                );
              })}
            </ul>
            <CardText>
              Nous vous conseillons de bien confirmer la date de ce RDV avec le propriétaire (par sms par exemple).
            </CardText>
          </Col>
        </Row>
      )}

      <Row className='mt-0 mb-0'>
        <Col className='col-12'>
          <hr />
        </Col>
        <Col className='col-6'>
          <CardText className='mb-1'>
            <strong>Adresse du bien</strong>
          </CardText>
        </Col>
        <Col className='col-6'>
          <CardText className='mb-1'>
            {o.opportunity.property.zipcode} - {o.opportunity.property.street_number} {o.opportunity.property.address}
          </CardText>
        </Col>
      </Row>
      <hr />
      <h2>Caractéristiques du bien</h2>
      <hr className='mt-0' />
      {o.opportunity.property.year && (
        <Row className='mt-0 mb-0'>
          <Col className='col-6'>
            <CardText className='mb-1'>
              <strong>Année de construction</strong>
            </CardText>
          </Col>
          <Col className='col-6'>
            <CardText className='mb-1'>{o.opportunity.property.year}</CardText>
          </Col>
        </Row>
      )}
      {o.opportunity.property.surface_land && (
        <Row className='mt-0 mb-0'>
          <Col className='col-6'>
            <CardText className='mb-1'>
              <strong>Surface du terrain</strong>
            </CardText>
          </Col>
          <Col className='col-6'>
            <CardText className='mb-1'>
              {o.opportunity.property.surface_land}m<sup>2</sup>
            </CardText>
          </Col>
        </Row>
      )}
      {o.opportunity.property.cellar_surface && (
        <Row className='mt-0 mb-0'>
          <Col className='col-6'>
            <CardText className='mb-1'>
              <strong>Surface de la cave</strong>
            </CardText>
          </Col>
          <Col className='col-6'>
            <CardText className='mb-1'>
              {o.opportunity.property.cellar_surface}m<sup>2</sup>
            </CardText>
          </Col>
        </Row>
      )}
      {o.opportunity.property.has_swimming_pool && (
        <Row className='mt-0 mb-0'>
          <Col className='col-6'>
            <CardText className='mb-1'>
              <strong>Possède une piscine</strong>
            </CardText>
          </Col>
          <Col className='col-6'>
            <CardText className='mb-1'>Oui</CardText>
          </Col>
        </Row>
      )}
      {o.opportunity.property.floor && (
        <Row className='mt-0 mb-0'>
          <Col className='col-6'>
            <CardText className='mb-1'>
              <strong>Nombre d'étages du batiment</strong>
            </CardText>
          </Col>
          <Col className='col-6'>
            <CardText className='mb-1'>{o.opportunity.property.number_floor}</CardText>
          </Col>
        </Row>
      )}
      {o.opportunity.property.number_floor && (
        <Row className='mt-0 mb-0'>
          <Col className='col-6'>
            <CardText className='mb-1'>
              <strong>Étage</strong>
            </CardText>
          </Col>
          <Col className='col-6'>
            <CardText className='mb-1'>{o.opportunity.property.floor}</CardText>
          </Col>
        </Row>
      )}
      {o.opportunity.property.garage_box && (
        <Row className='mt-0 mb-0'>
          <Col className='col-6'>
            <CardText className='mb-1'>
              <strong>Possède un garage</strong>
            </CardText>
          </Col>
          <Col className='col-6'>
            <CardText className='mb-1'>Oui</CardText>
          </Col>
        </Row>
      )}
      {o.opportunity.property.elevator && (
        <Row className='mt-0 mb-0'>
          <Col className='col-6'>
            <CardText className='mb-1'>
              <strong>Ascenseur</strong>
            </CardText>
          </Col>
          <Col className='col-6'>
            <CardText className='mb-1'>Oui</CardText>
          </Col>
        </Row>
      )}
      {o.opportunity.property.exposure && (
        <Row className='mt-0 mb-0'>
          <Col className='col-6'>
            <CardText className='mb-1'>
              <strong>Orientation</strong>
            </CardText>
          </Col>
          <Col className='col-6'>
            <CardText className='mb-1'>{exposure(o.opportunity.property.exposure)}</CardText>
          </Col>
        </Row>
      )}
      {o.opportunity.property.nb_rooms && (
        <Row className='mt-0 mb-0'>
          <Col className='col-6'>
            <CardText className='mb-1'>
              <strong>Nbr de pièces</strong>
            </CardText>
          </Col>
          <Col className='col-6'>
            <CardText className='mb-1'>{o.opportunity.property.nb_rooms}</CardText>
          </Col>
        </Row>
      )}
      {o.opportunity.property.nb_bathrooms && (
        <Row className='mt-0 mb-0'>
          <Col className='col-6'>
            <CardText className='mb-1'>
              <strong>Nbr de salle de bain</strong>
            </CardText>
          </Col>
          <Col className='col-6'>
            <CardText className='mb-1'>{o.opportunity.property.nb_bathrooms}</CardText>
          </Col>
        </Row>
      )}
      {o.opportunity.property.has_balcony_terrace && (
        <Row className='mt-0 mb-0'>
          <Col className='col-6'>
            <CardText className='mb-1'>
              <strong>Terrasse / balcon</strong>
            </CardText>
          </Col>
          <Col className='col-6'>
            <CardText className='mb-1'>Oui</CardText>
          </Col>
        </Row>
      )}
      {o.opportunity.property.balcony_terrace_surface && (
        <Row className='mt-0 mb-0'>
          <Col className='col-6'>
            <CardText className='mb-1'>
              <strong>Surface terrasse / balcon</strong>
            </CardText>
          </Col>
          <Col className='col-6'>
            <CardText className='mb-1'>
              {o.opportunity.property.balcony_terrace_surface}m<sup>2</sup>
            </CardText>
          </Col>
        </Row>
      )}

      <GoogleMaps
        containerHeight='330px'
        defaultZoom={defaultZoom}
        position={defaultPosition.latLng}
        defaultCenter={defaultPosition.latLng}
      />

      <hr className='mt-0' />
      <h2>Mes prochaines étapes</h2>
      <hr className='mt-0' />

      <Row className='mt-0 mb-0'>
        <Col className='col-6'>
          <CardText className='mb-1'>
            <span className='h3'>1 - J'appelle le lead</span>
          </CardText>
        </Col>
        <Col className='col-6'>
          <CardText className='mb-1'>
            <a href={'tel:' + o.opportunity?.owners?.[0].phone} className='btn btn-primary mr-2 btn-block'>
              <FormatPhoneNumber>{o.opportunity?.owners?.[0].phone}</FormatPhoneNumber>
            </a>
          </CardText>
        </Col>
      </Row>

      <Row className='mt-0 mb-0'>
        <Col className='col-6'>
          <CardText className='mb-1'>
            <span className='h3'>2 - Je mets à jour le statut du lead</span>
          </CardText>
        </Col>
        <Col className='col-6'></Col>
      </Row>

      <Row>
        <Col>
          <SelectLeadStatut opportunityAssignment={o} />
        </Col>
      </Row>
      <hr />
      <Row>
        <Col>
          <TextFieldComment opportunityAssignment={o} />
        </Col>
      </Row>

      <Row className='mt-0 mb-0'>
        <Col className='col-6'>
          <CardText className='mb-1'>
            <span className='h3'>3 - Je crée l'avis de valeur si le lead est intéressé</span>
          </CardText>
        </Col>
        <Col className='col-6'>
          <CardText className='mb-1'>
            <Button
              color={'greyblue'}
              className={'btn-block'}
              onClick={() => appRouter.goTo(`/${rapportPath}/${o.opportunity.id}`)}
            >
              <FontAwesomeIcon style={{ width: '1rem', marginRight: '0.5rem' }} icon={faEdit} />
              Éditer dans {capitalize(rapportPath)}
            </Button>
          </CardText>
        </Col>
      </Row>

      <Row className='mt-0 mb-0'>
        <Col className='col-6'>
          <CardText className='mb-1'>
            <span className='h3'>4 - Je crée le mandat</span>
          </CardText>
        </Col>
        <Col className='col-6'>
          <CardText className='mb-1'>
            {urlAffaire && (
              <a href={urlAffaire} className='btn btn-primary mr-2 btn-block' target={'blank'}>
                Lien vers mon affaire
              </a>
            )}
          </CardText>
        </Col>
      </Row>
    </>
  );
};

export default AssignmentInfos;
